import axios from "axios";
// 通用公用方法
const req = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/json",
      token: localStorage.getItem("logintoken")
    },
    data: params,
  }).then(res => res.data)
};

export { loginreq, req };



// WEBPACK FOOTER //
// ./src/api/axiosFun.js